// Permission slugs for the Shoppers CX Admin IPP domain.
// Convention: `domain.action` dotted slugs (see retailer-tools/docs/PERMISSIONS.md).
// These must also be created in IPP RBAC and mapped to the appropriate roles.
export enum Permission {
  // Gates the embedded (iframe) shopper-admin wrapper page and its L1 nav entry.
  ShopperAdminEmbeddedAppView = 'care_admin.embedded_shopper_admin_app.view',
}
